import { useEffect } from 'react';
import SubscriptionService from '../services/SubscriptionService';
import useObservable from './UseObservable';
import useResponseHandler from './UseResponseHandler';
import { path } from 'ramda';

const subscriptionService = SubscriptionService.getInstance();

function useSubscription() {
  const { success } = useResponseHandler();
  const [activePlan] = useObservable(subscriptionService.getActivePlan());
  const [availablePlans] = useObservable(subscriptionService.getAvailablePlans());
  const [subscription] = useObservable(subscriptionService.getSubscription());

  useEffect(() => {
    if (subscription && subscription.subscriptions && !subscription.outstanding_debt) {
      subscriptionService.getOutstandingDebt(subscription.subscriptions[0].id);
    }
    /* eslint-disable-next-line */
  }, [success])

  const cancelSubscription = (id: number) => subscriptionService.cancelSubscription(id);

  const createSubscription = async (body: any) => await subscriptionService.createSubscription(body);

  const getPremiumPlans = async () => await subscriptionService.getPremiumPlans();

  const fetchSubscription = async () => await subscriptionService.fetchSubscription();

  const getPendingAmountDue = async (id: number) => await subscriptionService.getPendingAmountDue(id);

  const updateSubscription = async (id: number, body: any) => subscriptionService.updateSubscription(id, body);

  const getPreviewUpdateSubscription = async (id: number, date: string, quantity: number) =>
    await subscriptionService.getPreviewUpdateSubscription(id, date, quantity);

  const isDemoUser = subscription?.subscriptionType === 'Demo';
  const isFreemiumUser = subscription?.subscriptionType === 'Free';
  const isPremium = subscription?.subscriptionType === 'Basic' || subscription?.subscriptionType === 'Plus';
  return {
    isDemoUser,
    isFreemiumUser,
    isPremium,
    activePlan,
    availablePlans,
    subscription,
    isSubscriptionCancel: path(['details', 'cancel_at_period_end'], subscription),
    getPremiumPlans,
    createSubscription,
    cancelSubscription,
    getPendingAmountDue,
    fetchSubscription,
    updateSubscription,
    getPreviewUpdateSubscription,
  };
}

export default useSubscription;
